// pages/mobile/installState.js
// Android browsers fire `beforeinstallprompt` once, often before the setup page
// opens, so it is captured as soon as the app loads and kept for the
// "Install app" button. iOS has no install API; the setup page shows a guide.
let deferredPrompt = null;
const listeners = new Set();

const notify = () => listeners.forEach((listener) => listener());

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    deferredPrompt = event;
    notify();
  });
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    notify();
  });
}

export const subscribeToInstallState = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const canPromptInstall = () => deferredPrompt !== null;

export const promptInstall = async () => {
  if (!deferredPrompt) return false;
  const prompt = deferredPrompt;
  deferredPrompt = null;
  prompt.prompt();
  const { outcome } = await prompt.userChoice;
  notify();
  return outcome === 'accepted';
};

export const isInstalled = () =>
  window.matchMedia?.('(display-mode: standalone)').matches === true || window.navigator.standalone === true;

export const isIos = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);

// Gmail, Outlook and other in-app browsers cannot add to the Home Screen.
export const isInAppBrowser = () => /GSA|Outlook|FBAN|FBAV|Instagram|Line\//i.test(window.navigator.userAgent);

export const notificationPermission = () =>
  typeof window.Notification === 'undefined' ? 'unsupported' : window.Notification.permission;

export const requestNotificationPermission = async () => {
  if (typeof window.Notification === 'undefined') return 'unsupported';
  return window.Notification.requestPermission();
};

// Test-only: forget a captured prompt between tests.
export const resetInstallStateForTests = () => {
  deferredPrompt = null;
  listeners.clear();
};
